export function getCurrentPage(offset: number, limit: number) {
  return Math.floor(offset / limit) + 1;
}
